"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

interface SiteHeaderBridgeProps {
  homeHeader: ReactNode;
  defaultHeader: ReactNode;
}

/** Picks header variant without `headers()` so pages can stay static/ISR. */
export default function SiteHeaderBridge({
  homeHeader,
  defaultHeader,
}: SiteHeaderBridgeProps): React.ReactElement {
  const pathname = usePathname();
  return <>{pathname === "/" ? homeHeader : defaultHeader}</>;
}
